import { Hero } from "@/components/home/Hero";
import { Work } from "@/components/home/Work";
import { About } from "@/components/home/About";
import { Contact } from "@/components/home/Contact";
import { Marquee } from "@/components/site/Marquee";
import { useMeta } from "@/lib/motion";

export default function Home() {
  useMeta(
    "Eldiiar Dzhumagaziev — Brand & Multidisciplinary Designer",
    "Portfolio of Eldiiar Dzhumagaziev, a UK-based junior brand and multidisciplinary designer working across brand identity, art direction, motion and visual storytelling.",
  );
  return (
    <>
      <Hero />
      <Marquee />
      <Work />
      <div className="mx-6 border-t border-ink/15 lg:mx-12" />
      <About />
      <Contact />
    </>
  );
}
